export const errorPage = (error) => {
    return {
        type: 'RT_ERROR_PAGE',
        payload: error
    }
}